/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiesactionactivate2Inputs */

const en_opportunitiesactionactivate2 = /** @type {(inputs: Opportunitiesactionactivate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supply without demand - activate`)
};

const de_opportunitiesactionactivate2 = /** @type {(inputs: Opportunitiesactionactivate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebot ohne Nachfrage - aktivieren`)
};

/**
* | output |
* | --- |
* | "Supply without demand - activate" |
*
* @param {Opportunitiesactionactivate2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiesactionactivate2 = /** @type {((inputs?: Opportunitiesactionactivate2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiesactionactivate2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiesactionactivate2(inputs)
	return de_opportunitiesactionactivate2(inputs)
});
export { opportunitiesactionactivate2 as "opportunitiesActionActivate" }